<template>
  <div>
    <CustomModalTemplate
      modalId="trail-files-modal"
      title="Arquivos"
      ref="form-modal"
      noCloseOnBackdrop
    >
      <template slot="header"><h4>Arquivos</h4></template>

      <template slot="content">
        <b-form id="alter-form" class="alter-form">
          <b-card class="custom-card my-4" border-variant="light">
            <b-form-row v-for="item in fileList" :key="item.nrOrder">
              <b-col>
                {{ item.fileName || "file" }}
              </b-col>
              <b-col>
                {{
                  item.principal ? "arquivo principal" : "arquivo complementar"
                }}
              </b-col>
              <b-col class="justify-content-end">
                <div >                  
                    <img
                    @click="onDownloadFile(item)"
                      class="button-custom"
                      src="@/assets/icons/download-outline.svg"
                    />                  
                </div>
              </b-col>
            </b-form-row>
          </b-card>
        </b-form>
      </template>

      <template slot="footer">
        <b-button
          variant="primary"
          class="ml-4"
          @click="$bvModal.hide('trail-files-modal')"
        >
          Fechar
        </b-button>
      </template>
    </CustomModalTemplate>
  </div>
</template>

<script>
import CustomModalTemplate from "../../../../components/custom-modal/CustomModalTemplate.vue";
import { getDocument } from "../../../../services/training/trainingService";
import { anchorBase64DownloadWithAtob } from "../../../../utils/anchor-base64-download/anchor-base64-download";
import { getMimeTypeByExtension } from "../../../../utils/File/mimeType";
export default {
  props: ["fileList"],
  components: { CustomModalTemplate },
  methods: {  
    async onDownloadFile(item) {
      console.log("onDownloadFile", item);
      
      try {
        // getDocument always returns base64 string
        const base64Data = await getDocument(item.link, item.fileName);
        
        // Determine file extension and MIME type
        const fileExtension = item.fileName ? 
          item.fileName.split('.').pop().toLowerCase() : 'pdf';
        const mimeType = getMimeTypeByExtension(fileExtension) || 'application/pdf';
        const fileNameWithExtension = item.fileName || `file.${fileExtension}`;
        
        // Use the anchorBase64Download utility for base64 data
        anchorBase64DownloadWithAtob(
          mimeType,
          fileNameWithExtension,
          base64Data.documentBase64
        );
      } catch (error) {
        console.error('Error downloading file:', error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  margin-right: 5px;
  &-size {
    color: var(--green-0);
    height: 3rem;
    width: 2.2rem;
  }
}

.button:hover {
  cursor: pointer;
}

.button-custom:hover {
  cursor: pointer;
}

.disable {
  opacity: 0.5;
}
</style>
